






















































































































import Vue from "vue";
import { mapGetters, mapState } from "vuex";

export default Vue.extend({
  name: "App",
  components: {},
  data: () => ({
    drawer: false
  }),
  computed: {
    ...mapGetters(["isLoggedIn", "isAdmin"]),
    ...mapState(["user"]),
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        default:
          return true;
      }
    }
  },
  watch: {
    mobile(value) {
      if (!value) {
        this.drawer = false;
      }
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("Logout");
    },
    darkMode() {
      localStorage.dark = this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    }
  }
});
